import { useEffect, useRef, useState } from "react";
import { getChatResponse, getVoiceResponse } from "../../utils/apiCalls";
import { useSpeechSynthesis } from "react-speech-kit";
import "./Chat.css";
import { Play } from "../../assets/svg";
import { Send } from "lucide-react";
import AudioRecorder from "../AudioRecorder/AudioRecorder";
import transcript from '../../assets/transcript.svg';
import voiceBot from "../../assets/voice_bot.svg";
import voiceUser from "../../assets/voice_user.svg";
import ChatMessageOverlay from "../ChatMessageOverlay/ChatMessageOverlay";

function Chat({ switcher, inputLanguage, outputLanguage }) {
  const [search, setSearch] = useState("");
  const [chatData, setChatData] = useState([{
    id: 'message0',
    type: 'text',
    text: 'Welcome to the conference',
    user: 'bot',
    task: {
      info: '',
      link: '',
      title: '',
    },
  }]);
  const [renderData, setRenderData] = useState([]);
  const { speak } = useSpeechSynthesis();
  const [botIsTyping, setBotIsTyping] = useState(false);

  const div = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [idMessage, setIdMessage] = useState(0);

  const handleClick = (message) => {
    setIsPlaying(!isPlaying);

    if (message && message.text) {
      speak({ text: JSON.stringify(message.text) });
    }
  };

  const chatObject = (id = null) => {
    let objectDate = new Date();
    let day = objectDate.getDate()
    let month = objectDate.getMonth()
    let year = objectDate.getFullYear()
    let hours = objectDate.getHours()
    let minutes = objectDate.getMinutes()
    let seconds = objectDate.getSeconds()

    if (hours < 10) {
      hours = '0' + hours;
    }
    if (minutes < 10) {
      minutes = '0' + minutes;
    }
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = `0${month}`;
    }
    let format = day + "/" + month + "/" + year + ' ' + hours + ':' + minutes + ':' + seconds;
    return {
      id: `message${id ? id : idMessage + 1}`,
      url: '',
      text: '',
      type: '',
      user: '',
      hasTask: false,
      avatar: '',
      task: {
        info: '',
        link: '',
        title: '',
      },
      date: format
    }
  }

  useEffect(() => {
    // console.log('chatData:', chatData)

    setRenderData(
      chatData
        .slice()
        // .reverse()
        .map((message, index) => (
          <ChatMessageOverlay key={index} message={message} index={index}>
            <div className="message-date">{message.date}</div>
            {switcher ? (
              message.type === 'text' ? (                
                  message.user === "bot" && (
                    <p className="chat__message-text">{message?.text || ''}</p>
                  )                
              ) : (
                <>
                  <div className="chat__play-visualizer">
                    <audio src={message.url} controls id={message.id} style={{ display: 'none' }} ></audio>
                    <button className={`chat__play-button ${message.user === "bot" ? "bot" : ""}`}
                      onClick={() => playAudio(message.id)}
                    >
                      <Play />
                    </button>
                    <img
                      src={`${message.user === "bot" ? voiceBot : voiceUser}`}
                      alt="voice"
                      height={45}
                      className="chat__message-voice"
                    />
                    {
                      message.user === "bot" && (
                        <button
                          className="chat__transcript-button bot"
                          onClick={() => showTranscript(message.id)}
                          title="Show Text Transcription"
                        >
                          <div>
                            <img src={transcript} />
                          </div>
                        </button>
                      )
                    }
                  </div>
                  {
                    message.user === "bot" && (
                      <div className={`chat__transcript-text ${message.id}`}>{message?.text}</div>
                    )
                  }
                </>
              )
            ) : (
              <>
                <p className="chat__message-text">{message?.text || ''}</p>
              </>
            )}
          </ChatMessageOverlay>
        ))
    );

  }, [chatData, switcher]);

  const onSearchChange = ({ target }) => {
    setSearch(target.value);
  };

  const playAudio = (id) => {
    document.getElementById(id).play();
  };

  const showTranscript = (id) => {
    document.getElementsByClassName(id)[0].style.display = "block"
  };

  const handleSendMessage = async (input, inputType = 'text') => {
    let nextId = idMessage + 1
    const userLocale = navigator.language || navigator.userLanguage;
    const userMessage = {
      'content': input,
      'input_type': inputType,
      'output_type': inputType,
      'locale': userLocale
    }
    setSearch("");

    setChatData((prev) => {
      const chatData = chatObject(nextId);
      chatData.user = 'user'
      chatData.text = input
      chatData.type = 'text'

      const newArr = [
        ...prev,
        chatData,
      ];

      return newArr;
    });
    setBotIsTyping(true);
    const result = await getChatResponse(userMessage, inputLanguage, outputLanguage);
    if (result.statusCode !== 200) {
      return false
    }

    if (result.hasOwnProperty("user_fields")) {
      if (result.user_fields.hasOwnProperty("$request.generative.response")) {
        delete result.user_fields["$request.generative.response"];
      }
      if (JSON.stringify(result.user_fields) !== JSON.stringify()) {
        console.log("changed");
      }
    }

    if (result) {
      nextId = nextId + 1
      setChatData((prev) => {
        let newObj = chatObject(nextId)
        let avatar;

        if (result.type === "text") {
          newObj.user = "bot"
          newObj.text = result.content
          newObj.avatar = avatar
          newObj.type = 'text'

        } else if (result.type === "image") {
          newObj.user = "bot"
          newObj.url = result.url
          newObj.avatar = avatar
          newObj.type = 'image'
        }

        const newArr = [
          ...prev,
          newObj,
        ];
        return newArr;
      });
    }
    setBotIsTyping(false);
    setIdMessage(nextId)
  };

  const onEnterPress = ({ keyCode }) => {
    if (keyCode === 13 && search.trim() !== "") {
      handleSendMessage(search);
    }
  };

  const addAudioElement = async (blob, transcript) => {
    if (!transcript) return null
    let nextId = idMessage + 1

    const url = URL.createObjectURL(blob);
    const userAudio = chatObject()
    userAudio.url = url
    userAudio.user = 'user'
    userAudio.type = "audio"
    userAudio.text = transcript
    setChatData((prev) => {
      const newArr = [
        ...prev,
        userAudio,
      ];

      return newArr;
    });
    nextId = nextId + 1
    setBotIsTyping(true);
    const blob64 = await blobToBase64(blob)
    console.log('blob64', blob64)
    const response = await getVoiceResponse(blob64, inputLanguage, outputLanguage)
    //const response = await getVoiceResponse(blob.text())
    //const response = await getVoiceResponse(transcript)
    if (response?.content) {
      // const blobResponse = b64toBlob(response.content, 'audio/ogg');
      // const botUrl = URL.createObjectURL(blobResponse);
      const botAudio = chatObject(nextId)
      // botAudio.url = botUrl
      botAudio.user = 'bot'
      botAudio.type = "text"
      botAudio.text = response.output_message

      setChatData((prev) => {
        const newArr = [
          ...prev,
          botAudio
        ];

        return newArr;
      });
      setIdMessage(nextId)
      setBotIsTyping(false);
    }
  };

  const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);
      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }
    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  function blobToBase64(blob) {
    return new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  }

  return (
    <>
      <div id="chat-container" className="chat-container">
        <div ref={div} id="chat-box" className="chat-box">
          {renderData}
          {botIsTyping && (
            <ChatMessageOverlay
              message={{ user: "bot", avatar: "default", type: "text" }}
              index={0}
            >
              <div className="typing">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
              </div>
            </ChatMessageOverlay>
          )}
        </div>
      </div>
      {
        switcher ? (
          <div className="input--search">
            <input
              className="chat-search"
              type="text"
              placeholder="Please start recording your voice here…"
              disabled
            />
            <div>
              <div>
                <AudioRecorder addAudioElement={addAudioElement} />
              </div>
            </div>
          </div>
        ) : (
          <div className="input--search">
            <input
              className="chat-search"
              type="text"
              placeholder="Please start typing here…"
              value={search}
              onChange={onSearchChange}
              onKeyDown={onEnterPress}
            />
            <div>
              <div className="input--send">
                <Send color="#fff" />
              </div>
            </div>
          </div>
        )
      }

    </>
  );
}

export default Chat;
